import { useState } from 'react';
import { Button } from '../components/Button';
import { Body, Screen, ScreenBody, Title } from '../components/Screen';
import { copy } from '../copy';
import { SHARE_CODE_LENGTH, isValidShareCode, normaliseShareCode } from '../lib/shareCode';

/**
 * /c — where a guest who took a code instead of giving a phone number lands.
 *
 * Unlike the kiosk, this is the guest's own phone, so a real text input with a
 * keyboard is right. The field normalises as they type, so O/0 and I/1 are
 * folded the way the lookup folds them and a hand-copied code still resolves.
 */
export function CodeEntryScreen({ onSubmit }: { onSubmit: (code: string) => void }) {
  const [value, setValue] = useState('');
  const valid = isValidShareCode(value);

  return (
    <Screen>
      <div className="pt-12" />
      <ScreenBody>
        <Title>{copy.codeEntry.heading}</Title>
        <Body>{copy.codeEntry.body}</Body>

        <input
          value={value}
          onChange={(e) => setValue(normaliseShareCode(e.target.value))}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && valid) onSubmit(value);
          }}
          inputMode="text"
          autoCapitalize="characters"
          autoCorrect="off"
          spellCheck={false}
          maxLength={SHARE_CODE_LENGTH}
          placeholder={copy.codeEntry.placeholder}
          aria-label="Retrieval code"
          className="w-full max-w-sm rounded-2xl border-2 border-bone/30 bg-transparent px-6 py-5 text-center font-display text-4xl tracking-[0.4em] text-bone placeholder:tracking-[0.2em] placeholder:text-bone/25 focus:border-straw focus:outline-none"
        />
      </ScreenBody>

      <div className="w-full max-w-sm pb-4">
        <Button onClick={() => onSubmit(value)} disabled={!valid}>
          {copy.codeEntry.cta}
        </Button>
      </div>
    </Screen>
  );
}
